import styled from 'styled-components';

interface Props {
  buttonBackground: string;
}

export const Wrapper = styled.div<Props>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;

  > button {
    width: 50px;
    height: 45px;
    border-radius: 10px;
    border: none;
    background: ${({ buttonBackground }) => buttonBackground};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`;
